<template>
  <BaseInput :label="label" :errors="errors" :hasIcon="hasIcon">
    <component :is="loadIconPath" v-if="iconType" :iconColor="iconColor" />
    <input
      type="file"
      :class="{ hasErrors: errors }"
      :name="name"
      :placeholder="placeholder"
      autocomplete="off"
      :accept="aceptedFileTypes"
      @change="$emit(`updateFile`, $event.target.files[0])"
    />

    <Paperclip />
  </BaseInput>
</template>

<script setup>
import { defineAsyncComponent, computed } from "vue";
import useFileInputValidations from "@/composables/validations/useFileInputValidations";
import BaseInput from "@/components/ui/inputs/BaseInput.vue";
import Paperclip from "@/components/icons/Paperclip.vue";

const { ACCEPTED_FILE_TYPES } = useFileInputValidations();

const props = defineProps({
  name: { type: String, default: "fileUploadField" },
  label: { type: String, default: "Default label" },
  placeholder: { type: String, default: "Default placeholder" },
  iconType: { type: String, required: false, default: "" },
  iconColor: { type: String, required: false },
  errors: {
    type: String,
    default: null,
  },
});
const $emit = defineEmits(["updateFile"]);
const aceptedFileTypes = ACCEPTED_FILE_TYPES.reduce(
  (item, acc) => (acc = `${item} ${acc}`),
  ""
).trim();
const hasIcon = !!props.iconType;
const loadIconPath = computed(() =>
  defineAsyncComponent(() =>
    import(
      /* @vite-ignore */ `../../icons/${props.iconType}.vue`
    )
  )
);
</script>

<style lang="scss">
input[type="file"]::file-selector-button {
  display: none;
}

.paperclip-icon {
  right: 10px;
  left: unset !important;
}
</style>
